/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pause': {
    width: 25,
    height: 25,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M512.862 1024a512 512 0 01-199.39-983.922 512 512 0 01398.78 942.841 508.994 508.994 0 01-199.39 41.08zm0-943.843C274.396 80.157 81.02 273.534 81.02 512s193.377 431.843 431.843 431.843S944.705 749.463 944.705 512 750.325 80.157 512.862 80.157z" _fill="#fff"/><path pid="1" d="M395.633 754.473a40.078 40.078 0 01-40.078-40.078V332.649a40.078 40.078 0 0180.156 0v381.746a40.078 40.078 0 01-40.078 40.078zm238.466 0a40.078 40.078 0 01-40.078-40.078V332.649a40.078 40.078 0 0180.156 0v381.746a40.078 40.078 0 01-40.078 40.078z" _fill="#fff"/>'
  }
})
